import './dashboard.scss'

import { defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue'

import { TrackingRoutes } from '@skinsoft/const'

import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { MovementFeaturedList, TaskFeaturedList } from '@skinsoft/entity-ui'

export const Dashboard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sMovementFeaturedList: MovementFeaturedList,
        sTaskFeaturedList: TaskFeaturedList,
    },
    template: require('./dashboard.html'),
    data() {
        return {
            Routes: TrackingRoutes,
        }
    },
    mounted() {
        (this.$refs.modal as InstanceType<typeof BModal>).show()
    },
    methods: {
        goBack() {
            this.$router.push(TrackingRoutes.MOVEMENTS)
        },
    },
})
